import {TARGETING_COOKIES} from 'constants/analytics';
import {waitForActivatingCookieGroup} from 'features/oneTrust/oneTrust';

type TrackConversionDataType = {
    orderId: string;
    clickid: string;
    customerId: string;
    customerStatus?: string;
    currencyCode?: string;
    customerEmail?: string;
    orderPromoCode?: string;
    email?: string;
    items?: Array<{
        category: string;
        quantity: number;
        sku: string;
        subTotal: number;
    }>;
};

/**
 * Track conversion.
 *
 * @param {TrackConversionDataType} data - Data for track conversion.
 * @param {string} id - ID for IR.
 */
export const trackConversion = async (data: TrackConversionDataType, id: number) => {
    try {
        await waitForActivatingCookieGroup(TARGETING_COOKIES);
        if (window.ire) {
            window.ire('trackConversion', id, data);
        }
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error);
    }
};
